

































import Vue from 'vue'
import dayjs from 'dayjs'
export default Vue.extend({
  props: {
    scrollY: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    selectedRowKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dayjs,
      customRow: (record) => {
        return {
          on: {
            // 事件
            click: () => {
              this.$emit('clickFile', record)
            }, // 点击行
            dblclick: () => {
              if (record.isfolder) {
                this.$emit('dblclickFlor', record)
              } else {
                this.$emit('dblclickFile', record)
              }
            }
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    onSelectChange(selectedRowKeys) {
      this.$emit('onSelectChange', selectedRowKeys)
    },
    icon(file) {
      let icon = 'file-unknown'
      if (file.isfolder === true) {
        icon = 'folder'
      } else {
        if (file.contentType && file.contentType.indexOf('image/') !== -1) {
          icon = 'file-image'
        } else {
          icon = 'file-text'
        }
      }
      return icon
    },
    color(file) {
      let color = '#52c41a'
      if (file.isfolder === true) {
        color = '#ffe17b'
      } else {
        if (file.contentType && file.contentType.indexOf('image/') !== -1) {
          color = '#71ce52'
        } else {
          color = '#92a8c1'
        }
      }
      return color
    }
  }
})
